<h2 mat-dialog-title class="av-section-title">{{ 'backoffice.billing.refunds.dialog_title' | translate }}</h2>

<mat-dialog-content class="d-flex flex-column gap-3">
  <p class="av-section-hint m-0">{{ 'backoffice.billing.refunds.dialog_hint' | translate }}</p>

  <dl class="d-flex flex-column gap-2 m-0">
    <div class="d-flex justify-content-between gap-3">
      <dt class="av-meta">{{ 'backoffice.common.reason_dialog.organization' | translate }}</dt>
      <dd class="m-0 cell-strong text-end" data-testid="refund-organization">
        {{ data.organizationName }}
      </dd>
    </div>

    <div class="d-flex justify-content-between gap-3">
      <dt class="av-meta">{{ 'backoffice.billing.refunds.payment' | translate }}</dt>
      <dd class="m-0 text-end av-source">{{ data.paymentReference }}</dd>
    </div>

    <div class="d-flex justify-content-between gap-3">
      <dt class="av-meta">{{ 'backoffice.billing.refunds.remainder_label' | translate }}</dt>
      <dd class="m-0 cell-strong text-end" data-testid="refund-remainder">
        {{ data.refundableRemainder }} {{ data.currency || '' }}
      </dd>
    </div>
  </dl>

  <div class="av-banner p-3 d-flex align-items-start gap-2" data-testid="refund-not-from-cancel">
    <mat-icon aria-hidden="true">info</mat-icon>
    <span>{{ 'backoffice.billing.refunds.not_from_cancellation' | translate }}</span>
  </div>

  <form [formGroup]="formGroup" class="d-flex flex-column gap-3">
    <label class="d-flex flex-column gap-1" for="refund-amount">
      <span class="av-meta">{{ 'backoffice.billing.refunds.amount_label' | translate }}</span>
      <input
        id="refund-amount"
        type="number"
        step="0.01"
        min="0"
        class="av-field"
        [attr.max]="data.refundableRemainder"
        formControlName="amount"
        data-testid="refund-amount-input"
      />
    </label>

    @if (!isAmountValid()) {
      <p class="av-meta m-0" data-testid="refund-amount-invalid">
        {{ 'backoffice.billing.refunds.amount_invalid' | translate }}
      </p>
    }

    <label class="d-flex flex-column gap-1" for="refund-reason">
      <span class="av-meta">{{ 'backoffice.billing.refunds.reason_label' | translate }}</span>
      <select id="refund-reason" class="av-field" formControlName="reason">
        @for (reason of reasonOptions; track reason) {
          <option [value]="reason">{{ reasonLabels[reason] | translate }}</option>
        }
      </select>
    </label>

    <label class="d-flex flex-column gap-1" for="refund-note">
      <span class="av-meta">{{ 'backoffice.billing.refunds.note_label' | translate }}</span>
      <textarea
        id="refund-note"
        class="av-field"
        rows="3"
        [attr.maxlength]="noteMax"
        formControlName="note"
      ></textarea>
    </label>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="d-flex justify-content-end gap-2">
  <button type="button" class="av-btn" (click)="dismiss()">{{ 'backoffice.common.actions.cancel' | translate }}</button>

  <button
    type="button"
    class="av-btn av-btn-primary"
    [disabled]="!formGroup.valid || !isAmountValid()"
    (click)="confirm()"
    data-testid="refund-submit"
  >
    {{ 'backoffice.billing.refunds.submit' | translate }}
  </button>
</mat-dialog-actions>
